/**
 * iOS-устройство (iPhone / iPad / iPod), включая iPadOS 13+,
 * который в User-Agent маскируется под macOS.
 * Нужна для страницы перевыпуска карты: .pkpass бесполезен вне iOS.
 */
export const isIOSDevice = (): boolean => {
    const { userAgent, maxTouchPoints } = window.navigator
    const isIPhoneLike = /iPhone|iPad|iPod/i.test(userAgent)
    const isIPadOS = /Macintosh/i.test(userAgent) && maxTouchPoints > 1
    return isIPhoneLike || isIPadOS
}
